/**
 * Standalone Hero Component
 * Wrapper that fetches a film and renders HeroSection
 */

import { useState, useEffect } from '@wordpress/element';
import { useFilms } from '../context/FilmContext';
import HeroSection from './HeroSection';
import TrailerModal from './TrailerModal';

export default function StandaloneHero({ source = 'pick-of-day', filmId }) {
    const { fetchPickOfDay, fetchPickOfWeek, fetchWhatsPlaying, fetchFilm, fetchFilms, loading } = useFilms();
    const [film, setFilm] = useState(null);
    const [trailerFilm, setTrailerFilm] = useState(null);

    useEffect(() => {
        loadFilm();
    }, [source, filmId]);

    const loadFilm = async () => {
        let result = null;

        switch (source) {
            case 'pick-of-day': {
                const data = await fetchPickOfDay();
                result = data?.pick?.film || null;
                break;
            }
            case 'pick-of-week': {
                const data = await fetchPickOfWeek();
                result = data?.pick?.film || null;
                break;
            }
            case 'whats-playing': {
                const data = await fetchWhatsPlaying();
                result = data?.current?.film || data?.upcoming?.[0]?.film || null;
                break;
            }
            case 'next-screening': {
                const data = await fetchFilms({ per_page: 1, orderby: 'next_screening' });
                result = data?.films?.[0] || null;
                break;
            }
            case 'random': {
                const data = await fetchFilms({ per_page: 1, orderby: 'rand' });
                result = data?.films?.[0] || null;
                break;
            }
            case 'specific': {
                if (filmId) {
                    result = await fetchFilm(filmId);
                }
                break;
            }
        }

        setFilm(result);
    };

    if (loading && !film) {
        return (
            <div className="rialto-loading">
                <div className="rialto-spinner"></div>
            </div>
        );
    }

    if (!film) return null;

    return (
        <>
            <HeroSection
                film={film}
                onTrailerClick={(f) => setTrailerFilm(f)}
            />
            <TrailerModal
                film={trailerFilm}
                isOpen={!!trailerFilm}
                onClose={() => setTrailerFilm(null)}
            />
        </>
    );
}
